@if (!openDetails) {
<div [ngClass]="{ 'mt-web': !isSourceFordPass }" class="open-schedule">
  <div class="open-schedule__schedule">
    @for (schedule of scheduleData; track schedule.scheduleId) {
    <app-open-schedule-card [schedule]="schedule" [isProjectStatus]="true" (removed)="removeSchedule($event)"
      (detailsToogle)="verifyDetailsState($event)" />
    }

    <div class="open-schedule__schedule__status" [ngClass]="{'hide': openDetails}">
      <div class="open-schedule__schedule__icon-box">
        <img src="../../../../../assets/img/Icon_Car_Info.svg" alt="Car info icon">
      </div>
      <p class="open-schedule__schedule__text__title">{{ "schedule.tracking" | translate }}</p>
      <span class="open-schedule__schedule__text__description">{{ "schedule.tracking-info" | translate }}</span>

      <div class="open-schedule__schedule__status-tracker">
        <div class="open-schedule__schedule__status-tracker__tracker">
          <fds-compact-vertical-tracker [simple]="true" [firstItem]="true" [inProgress]="true">
            <span class="content">{{ "dashboard.vehicle-dealer" | translate }}</span>
          </fds-compact-vertical-tracker>
          <fds-compact-vertical-tracker [simple]="true" [inProgress]="true">
            <span class="content">{{ "dashboard.checklist-vehicle" | translate }}</span>
          </fds-compact-vertical-tracker>
          <fds-compact-vertical-tracker [simple]="true" [inProgress]="true">
            <span class="content">{{ "dashboard.vehicle-delivery" | translate }}</span>
          </fds-compact-vertical-tracker>
        </div>
      </div>
    </div>
  </div>
</div>
} @else {
  <app-details [driveInformation]="driveInformation" [isProjectStatus]="true" (handleDetails)="verifyDetailsState($event)" />
}
